<template>
  <Toast>
    <template
      #container="{ message: { severity, summary, detail }, closeCallback }"
    >
      <div class="flex flex-auto flex-col items-start px-3 py-2">
        <div class="flex w-full items-center justify-between">
          <div class="flex items-center gap-2">
            <RiCheckboxCircleFill
              v-if="severity === 'success'"
              class="size-4 shrink-0"
            />
            <RiErrorWarningFill
              v-if="severity === 'error'"
              class="size-4 shrink-0"
            />
            <span :class="[detail ? 'font-medium' : 'font-normal']">
              {{ summary }}
            </span>
          </div>

          <button
            type="button"
            :aria-label="$t('global.actions.close')"
            @click="closeCallback"
          >
            <RiCloseLine class="size-4 text-white" />
          </button>
        </div>
        <p v-if="detail">
          {{ detail }}
        </p>
      </div>
    </template>
  </Toast>

  <Toast group="quotation-sent">
    <template #container="{ message: { summary, detail }, closeCallback }">
      <div class="flex flex-auto flex-col items-start px-3 py-2">
        <div class="flex w-full items-center justify-between">
          <div class="flex items-center gap-2">
            <RiCheckboxCircleFill class="size-4 shrink-0" />
            <span :class="[detail ? 'font-medium' : 'font-normal']">
              {{ summary }}
            </span>
          </div>

          <button
            type="button"
            :aria-label="$t('global.actions.close')"
            @click="closeCallback"
          >
            <RiCloseLine class="size-4 text-white" />
          </button>
        </div>
        <p v-if="detail.message">
          {{ detail.message }}
        </p>
        <div class="mt-2 text-sm">
          <div v-if="detail.country" class="flex items-center gap-1">
            <span class="font-medium">Country:</span> {{ detail.country.name }}
            <BaseCountryFlag
              :country-code="detail.country.isoCode"
              class="w-5"
            />
          </div>
          <div class="flex items-center gap-1">
            <span class="font-medium">Operator name:</span>
            <BaseHiddenText
              :text="detail.operatorName"
              :hidden-text-length="24"
            />
          </div>
        </div>
        <button
          @click="
            () => {
              closeCallback()
              navigateTo('/projects?tab=quotations')
            }
          "
          class="mt-4 flex items-center gap-2 underline underline-offset-4"
        >
          <span>View quotations</span>
          <RiExternalLinkLine class="size-4" />
        </button>
      </div>
    </template>
  </Toast>
</template>

<script setup lang="ts">
import RiCheckboxCircleFill from '~icons/ri/checkbox-circle-fill'
import RiCloseLine from '~icons/ri/close-line'
import RiErrorWarningFill from '~icons/ri/error-warning-fill'
import RiExternalLinkLine from '~icons/ri/external-link-line'
import BaseCountryFlag from '@/components/BaseCountryFlag.vue'
import { navigateTo } from '@/utils/navigate-to'
import BaseHiddenText from '@/components/BaseHiddenText.vue'
</script>
